/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PutApiV1PersonIdRolesMutationRequest,
  PutApiV1PersonIdRolesMutationResponse,
  PutApiV1PersonIdRolesPathParams,
  PutApiV1PersonIdRoles400,
  PutApiV1PersonIdRoles401,
  PutApiV1PersonIdRoles404,
  PutApiV1PersonIdRoles500,
} from "../../types/personRegisterController/PutApiV1PersonIdRoles.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { putApiV1PersonIdRoles } from "../../clients/personRegisterController/putApiV1PersonIdRoles.ts";

export const putApiV1PersonIdRolesMutationKey = () =>
  [{ url: "/api/v1/person/:id/roles" }] as const;

export type PutApiV1PersonIdRolesMutationKey = ReturnType<
  typeof putApiV1PersonIdRolesMutationKey
>;

export function putApiV1PersonIdRolesMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PutApiV1PersonIdRolesMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const mutationKey = putApiV1PersonIdRolesMutationKey();
  return mutationOptions<
    PutApiV1PersonIdRolesMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdRoles400
      | PutApiV1PersonIdRoles401
      | PutApiV1PersonIdRoles404
      | PutApiV1PersonIdRoles500
    >,
    {
      id: PutApiV1PersonIdRolesPathParams["id"];
      data?: PutApiV1PersonIdRolesMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id, data }) => {
      return putApiV1PersonIdRoles(id, data, config);
    },
  });
}

/**
 * @description Atualiza parcialmente os papéis da pessoa. Apenas as flags informadas serão alteradas. **(Requer Authorization para autenticação)**
 * @summary Atualizar papéis da pessoa (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/roles}
 */
export function usePutApiV1PersonIdRoles<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PutApiV1PersonIdRolesMutationResponse,
      ResponseErrorConfig<
        | PutApiV1PersonIdRoles400
        | PutApiV1PersonIdRoles401
        | PutApiV1PersonIdRoles404
        | PutApiV1PersonIdRoles500
      >,
      {
        id: PutApiV1PersonIdRolesPathParams["id"];
        data?: PutApiV1PersonIdRolesMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PutApiV1PersonIdRolesMutationRequest>> & {
      client?: Client;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? putApiV1PersonIdRolesMutationKey();

  const baseOptions = putApiV1PersonIdRolesMutationOptions(
    config,
  ) as UseMutationOptions<
    PutApiV1PersonIdRolesMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdRoles400
      | PutApiV1PersonIdRoles401
      | PutApiV1PersonIdRoles404
      | PutApiV1PersonIdRoles500
    >,
    {
      id: PutApiV1PersonIdRolesPathParams["id"];
      data?: PutApiV1PersonIdRolesMutationRequest;
    },
    TContext
  >;

  return useMutation<
    PutApiV1PersonIdRolesMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdRoles400
      | PutApiV1PersonIdRoles401
      | PutApiV1PersonIdRoles404
      | PutApiV1PersonIdRoles500
    >,
    {
      id: PutApiV1PersonIdRolesPathParams["id"];
      data?: PutApiV1PersonIdRolesMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PutApiV1PersonIdRolesMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdRoles400
      | PutApiV1PersonIdRoles401
      | PutApiV1PersonIdRoles404
      | PutApiV1PersonIdRoles500
    >,
    {
      id: PutApiV1PersonIdRolesPathParams["id"];
      data?: PutApiV1PersonIdRolesMutationRequest;
    },
    TContext
  >;
}
